import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import axios from "axios";
import { BookingEditableField, IBooking, IBookingPermission, ReactQueryKey } from "../../types";

export interface IGetBookingByIdWithMetaReturn {
    booking: IBooking,
    permissions: IBookingPermission,
    editableFields: BookingEditableField[]
}

export const getBookingByIdWithMeta = async (id: string, language:string): Promise<IGetBookingByIdWithMetaReturn> => {
    const response = await axios.get(`booking/findByIdWithMeta/${id}?language=${language}`);
    return response.data;
};


export const useBookingByIdWithMetaQueryObserver = (id?: string) => {
    return useQuery<IGetBookingByIdWithMetaReturn | null>({
        queryKey: [ReactQueryKey.BookingById, id],
        enabled: false
    });
};
